import {CARREGAR_MAPA_POLYS, CARREGAR_MAPA_POLYS_SERVER} from '../constants/constants'

export const carregarMapaNaStore = (mapa) =>({
    type : CARREGAR_MAPA_POLYS,
    mapa
}) 

export const carregarMapaDoServer = () =>({
    type : CARREGAR_MAPA_POLYS_SERVER
})

window.carregarMapaDoServer = carregarMapaDoServer;
window.carregarMapaNaStore = carregarMapaNaStore;


// WEBPACK FOOTER //
// ./src/actions/mapa.js